<template>
  <div
    class="rounded-lg border-2 border-black-dark bg-white dark:bg-kekkle-dark-light"
    :class="[shadowClass, paddingClass]"
  >
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { ShadowColor, PaddingSize } from "@/types/ui/kekkle";

type Props = {
  shadow?: ShadowColor;
  padding?: PaddingSize;
};

const { shadow = "yellow", padding = "normal" } = defineProps<Props>();

const shadowClass = computed(() => `shadow-${shadow}-hard`);

const paddingClass = computed(() => {
  switch (padding) {
    case "small":
      return "p-2";
    case "normal":
      return "p-4 md:p-6";
    case "large":
      return "p-6 md:p-8";
    case "none":
      return "";
    default:
      return "p-4 md:p-6";
  }
});
</script>
